import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomAnchor from "../../shared/Anchor/CustomAnchor";
import ImageRender from "../image-render/ImageRender";
import "./AchievementCard.css";
import { faYoutube, IconDefinition } from "@fortawesome/free-brands-svg-icons";
import { faFile, faFilePdf } from "@fortawesome/free-regular-svg-icons";

type AchievementCardProps = {
  data: {
    cover: string;
    type: string;
    link: string;
    title: string;
  };
};

function AchievementCard({ data }: AchievementCardProps) {  
  const getResourceLink = (resource: string, type: string): string => {
    switch (type) {
      case "document":
        return require("../../assets/documents/TDMAPCertificate.pdf");
      default:
        return resource;
    }
  };

  const getResourceFileType = (
    resource: string,
    type: string
  ): IconDefinition | undefined | null => {
    switch (type) {
      case "youtube":
        return faYoutube;
      case "document":
        return resource?.includes(".pdf") ? faFilePdf : faFile;
      default:
        return null;
    }
  };

  return (
    <CustomAnchor
      classname="achievement-cover-container"
      path={getResourceLink(data.link, data.type)}
      openOverlay={{
        path: getResourceLink(data.link, data.type),
        type: data.type,
        title: data.type,
      }}
    >
      <div className="card h-100">
        <div className="card-body">
          <ImageRender
            path={require(`../../assets/images/covers/${data.cover}`)}
            classname="achievement-cover"
          />
        </div>
        <div className="card-footer">
          <h4 className="d-flex align-items-start gap-2">
            <FontAwesomeIcon
              icon={getResourceFileType(data.link, data.type)!}
              className="text-danger"
            />
            <span>{data.title}</span>
          </h4>
        </div>
      </div>
    </CustomAnchor>
  );
}

export default AchievementCard;
